// start:ng42.barrel
export * from './app.config';
export * from './locale.config';
// end:ng42.barrel



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/config/index.ts